import { Text, HStack, PlusIcon } from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton } from '../../../ecg/components/CustomButton';
import {
  disableMergeSelector,
  selectedBaseClustersSelector,
} from '../../selectors/cluster.selectors';
import { mergeClusters } from '../../thunks/merge-clusters.thunk';

interface Props {
  morphologyNumber: number;
}

export const MorphologiesHeader: React.FC<Props> = ({ morphologyNumber }) => {
  const dispatch = useDispatch();
  const selectedBaseClusters = useSelector(selectedBaseClustersSelector);
  const createNewMorphology = useCallback(async () => {
    await dispatch(mergeClusters(selectedBaseClusters));
  }, [dispatch, selectedBaseClusters]);
  const disabled = useSelector(disableMergeSelector);

  return (
    <HStack spacing='xl'>
      <Text textStyle='label'>Morphologies ({morphologyNumber})</Text>
      <CustomButton
        disabled={disabled}
        dataTestId='new-morphology-btn'
        onClick={createNewMorphology}
        rightIcon={<PlusIcon />}
      >
        Create New Morphology
      </CustomButton>
    </HStack>
  );
};
